import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17cfca14"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal",
  "data-keyboard": "true",
  tabindex: "-1",
  role: "dialog",
  id: "google-job-modal",
  "aria-labelledby": "`personal-job-modal-label`",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered modal-xl",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "google-job-modal-label"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "form-group row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 col-form-label" }, "Date", -1))
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-group row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 col-form-label" }, "Inspector", -1))
const _hoisted_14 = { class: "col-sm-8" }
const _hoisted_15 = { class: "form-group row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 col-form-label" }, "Timing", -1))
const _hoisted_17 = { class: "col-md-4 pr-0" }
const _hoisted_18 = { class: "col-md-4 pl-0" }
const _hoisted_19 = { class: "form-group row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 col-form-label" }, "Summary", -1))
const _hoisted_21 = { class: "col-md-8 pr-0" }
const _hoisted_22 = { class: "form-group row" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-md-2 col-form-label" }, "Description", -1))
const _hoisted_24 = { class: "col-md-8 pr-0" }
const _hoisted_25 = { class: "modal-footer" }
const _hoisted_26 = {
  key: 0,
  id: "status-bar-switches",
  style: {"margin-right":"auto"}
}
const _hoisted_27 = { class: "custom-control custom-switch" }
const _hoisted_28 = ["checked"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "issuedCheckBox"
}, " Issued ", -1))
const _hoisted_30 = ["disabled"]

import $ from 'jquery';
import { computed, ref, onMounted, inject, watch, nextTick } from 'vue';
import moment from "moment-timezone";
import { v4 as uuidv4 } from 'uuid';
import { DxDateBox } from "devextreme-vue/date-box";
import TiptapEditor from "@/components/editor/TiptapEditor.vue";
import { Booking, Inspector, Location, SelectOption, ReportTiming } from "@/models";
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'GoogleJobModal',
  props: {
    booking: {}
  },
  emits: ['hide'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const store = useStore();
const actProperty: any = inject('actProperty');
const emit = __emit

const googlebooking = ref(new Booking());
const selectedinspector = ref(new Inspector());
const subjobdate = ref(new Date());
const description = ref("");
const tiptapeditorkey = ref(uuidv4());
const isSaving = ref(false);

const dynamicRefs = ref({});

const realtime: any = inject('realtime');
const channel = realtime.channels.get('diary');
const deviceid = actProperty.getDeviceId();

const inspectors = computed((): Inspector[] => store.getters['diary/inspectorlist']);
const inspectorinstringsearchfilter = ref('');

const saveBooking = async (booking: Booking): Promise<Booking> => {
  return store.dispatch('diary/saveBooking', booking);
};

onMounted(async () => {
  Promise.all([setStartTimeOptions(), setEndTimeOptions()])
    .then((values) => { })
    .catch((err) => {
      actProperty.displayError(err);
    });
});

const init = () => {
  googlebooking.value = new Booking(props.booking);
  subjobdate.value = props.booking.startdateAsDate;
  selectedinspector.value = props.booking.inspector;
  description.value = props.booking.description;
  tiptapeditorkey.value = uuidv4();
}

const edit = () => {

}

const starttimeoptions = ref<string[]>([]);
const endtimeoptions = ref<string[]>([]);
const appointmenttimeoptions = ref<string[]>([]);
const setStartTimeOptions = () => {
  starttimeoptions.value = [];
  let startmoment = moment().set("hour", 6).set("minute", 0);
  for (let i = 0; i < 62; i++) {
    const hourMinutes = startmoment.format("hh:mm A");
    starttimeoptions.value.push(hourMinutes);
    appointmenttimeoptions.value.push(hourMinutes);
    startmoment.add(15, "minutes");
  }
}

const setEndTimeOptions = () => {
  endtimeoptions.value = [];
  let startmoment = moment().set("hour", 6).set("minute", 0);
  if (_startdate.value) {
    startmoment = moment(_startdate.value, "hh:mm A");
    startmoment.add(15, "minutes");
  }
  for (let i = 0; i < 62; i++) {
    const hourMinutes = startmoment.format("hh:mm A");
    endtimeoptions.value.push(hourMinutes);
    startmoment.add(15, "minutes");
    if (hourMinutes === "09:00 PM ") break;
  }
}

const _startdate = computed({
  get: () => {
    let value = googlebooking.value.startdate
      ? moment(googlebooking.value.startdate).utc().format("hh:mm A")
      : "";
    const index = starttimeoptions.value.findIndex(
      (option: string) => option === value
    );
    if (index < 0) value = "";
    return value;
  },
  set: (val: string) => {
    googlebooking.value.startdate = subjobendDate(
      val,
      googlebooking.value.startdateAsDate
    );
  }
});

const _enddate = computed({
  get: () => {
    let value = googlebooking.value.enddate
      ? moment(googlebooking.value.enddate).utc().format("hh:mm A")
      : "";
    const index = endtimeoptions.value.findIndex(
      (option: string) => option === value
    );
    if (index < 0) value = "";
    return value;
  },
  set: (val: string) => {
    googlebooking.value.enddate = subjobendDate(
      val,
      googlebooking.value.startdateAsDate
    );
    let duration = googlebooking.value.duration;
    if (duration === googlebooking.value.recommendedtime) duration = 0;
    googlebooking.value.preferredduration = duration;
  }
});

const subjobendDate = (time: string, date: Date) => {
  let value = "";
  if (time) {
    let dt: Date = date ? date : subjobdate.value;
    let justdate = moment(dt).utc().format("YYYY-MM-DD");
    let justtime = moment(time, "hh:mm A").format("HH:mm");
    value = `${justdate}T${justtime}:00.000Z`;
  }
  return value;
}

watch(() => _startdate.value, (newValue) => {
  setEndTimeOptions();
});

const customLabel = (option: string) => {
  return option.replace(/^0/, '');
}

const inspectorlistinstring = computed(() => {
  return inspectors.value
    .sort((i1, i2) => i1.name.toLowerCase().localeCompare(i2.name.toLowerCase()))
    .filter(i => i.name.toLowerCase() != "default" && (!inspectorinstringsearchfilter.value || i.name.toLowerCase().startsWith(inspectorinstringsearchfilter.value.toLowerCase())))
    .map(i => i.name);
});

const inspector = computed({
  get: () => {
    const insp = inspectors.value.find(i => i.id === selectedinspector.value.id);
    return insp?.name ?? '';
  },
  set: (val: string) => {
    if (val) {
      const insp = inspectors.value.find(i => i.name === val);
      if (insp) {
        selectedinspector.value = insp;
      }
    }
  }
});

const resetInspector = () => {
  selectedinspector.value = new Inspector();
};

const summary = computed({
  get: () => googlebooking.value.summary,
  set: (val: string) => {
    googlebooking.value.summary = val;
  }
});

const pinotes = computed({
  get: () => googlebooking.value.pinotes,
  set: (val: string) => {
    googlebooking.value.pinotes = val;
  }
});

const setDescription = (val: string) => {
  description.value = val;
}

const issued = computed(() => {
  return googlebooking.value.issued;
});
const toggleIssued = () => {
  googlebooking.value.issued = !googlebooking.value.issued;
}

const convertToHoursMinutes = (val: number) => {
  let hourMinutes = moment
    .utc()
    .startOf("day")
    .add(val, "minutes")
    .format("HH [Hours] mm [Minutes]");
  hourMinutes = hourMinutes.replaceAll("00 Hours", "");
  hourMinutes = hourMinutes.replaceAll("00 Minutes", "");
  return hourMinutes;
}

const dropDownOpened = (ref: string) =>{
  nextTick(() => {
    // Get the reference to the dropdown list container
    const multiselect = dynamicRefs.value[ref] as any;
    const dropdownList = multiselect.$el.querySelector('.multiselect__content-wrapper');

    // Get the reference to the selected option element
    const selectedOption = multiselect.$el.querySelector('.multiselect__option--selected');

    // Scroll to the position of the selected element
    if(selectedOption?.offsetTop)
      dropdownList.scrollTop = selectedOption.offsetTop;
  });
}

const savingAllowed = computed(() => {
  let result = false;
  if (selectedinspector.value && selectedinspector.value.id && subjobdate.value)
    result = true;
  return result;
});

const save = async () => {
  hide();
  if (selectedinspector.value.id) {
    isSaving.value = true;
    googlebooking.value.inspector = selectedinspector.value;
    googlebooking.value.startdate = subjobendDate(
      googlebooking.value.starttime,
      subjobdate.value
    );
    googlebooking.value.enddate = subjobendDate(
      googlebooking.value.endtime,
      subjobdate.value
    );
    if (props.booking.googleid) {
      googlebooking.value.description = description.value;
    }
    try {
      await saveBooking(googlebooking.value);
      channel.publish('appointmentChanged', { deviceid: deviceid, bookingid: googlebooking.value.id, source: 'Scheduler' });
    } catch (err: any) {
      actProperty.displayError(err);
    } finally {
      isSaving.value = false;
    }
  }
};

const show = () => {
  if ($('#google-job-modal-Backdrop').length == 0) {
    const backdropDiv = $('<div class="modal-backdrop fade show" id="google-job-modal-Backdrop"></div>');
    $('body').append(backdropDiv);
    $(`#google-job-modal`).show();
  }
}
const hide = () => {
  if ($('#google-job-modal-Backdrop').length > 0) {
    $('#google-job-modal-Backdrop').remove();
    $(`#google-job-modal`).hide();
  }
};

__expose({show, init, edit, hide})

return (_ctx: any,_cache: any) => {
  const _component_singleselect_text = _resolveComponent("singleselect-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.booking.summary), 1),
          _createElementVNode("button", {
            id: "close",
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("form", null, [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_unref(DxDateBox), {
                    modelValue: subjobdate.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((subjobdate).value = $event)),
                    "display-format": "dd/MM/yyyy",
                    type: "date",
                    "picker-type": "calendar",
                    "apply-value-mode": "instantly",
                    calendarOptions: {firstDayOfWeek:1}
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_singleselect_text, {
                    modelValue: inspector.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inspector).value = $event)),
                    options: inspectorlistinstring.value,
                    "allow-empty": true,
                    taggable: false,
                    onSearchChange: _cache[3] || (_cache[3] = ($event: any) => (inspectorinstringsearchfilter.value = $event)),
                    ref: el => { dynamicRefs.value['inspectorDropDown'] = el },
                    onOpen: _cache[4] || (_cache[4] = ($event: any) => (dropDownOpened('inspectorDropDown')))
                  }, _createSlots({ _: 2 }, [
                    (selectedinspector.value && selectedinspector.value.id)
                      ? {
                          name: "clear",
                          fn: _withCtx(() => [
                            _createElementVNode("i", {
                              onMousedown: _withModifiers(resetInspector, ["prevent","stop"]),
                              class: "multiselect__clear fa fa-times",
                              "aria-label": "Clear inspector"
                            }, null, 32)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_singleselect_text, {
                    modelValue: _startdate.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_startdate).value = $event)),
                    options: starttimeoptions.value,
                    customLabel: customLabel,
                    "allow-empty": true,
                    taggable: false,
                    ref: el => { dynamicRefs.value['startDateDropDown'] = el },
                    onOpen: _cache[7] || (_cache[7] = ($event: any) => (dropDownOpened('startDateDropDown')))
                  }, _createSlots({ _: 2 }, [
                    (_startdate.value)
                      ? {
                          name: "clear",
                          fn: _withCtx(() => [
                            _createElementVNode("i", {
                              onMousedown: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_startdate.value = ''), ["prevent","stop"])),
                              class: "multiselect__clear fa fa-times",
                              "aria-label": "Clear Start Time"
                            }, null, 32)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_singleselect_text, {
                    modelValue: _enddate.value,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_enddate).value = $event)),
                    options: endtimeoptions.value,
                    customLabel: customLabel,
                    "allow-empty": true,
                    taggable: false,
                    ref: el => { dynamicRefs.value['endDateDropDown'] = el },
                    onOpen: _cache[10] || (_cache[10] = ($event: any) => (dropDownOpened('endDateDropDown')))
                  }, _createSlots({ _: 2 }, [
                    (_enddate.value)
                      ? {
                          name: "clear",
                          fn: _withCtx(() => [
                            _createElementVNode("i", {
                              onMousedown: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_enddate.value = ''), ["prevent","stop"])),
                              class: "multiselect__clear fa fa-times",
                              "aria-label": "Clear End Time"
                            }, null, 32)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["modelValue", "options"])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((summary).value = $event)),
                    type: "text",
                    class: "form-control"
                  }, null, 512), [
                    [
                      _vModelText,
                      summary.value,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  (_openBlock(), _createBlock(TiptapEditor, {
                    key: tiptapeditorkey.value,
                    content: description.value,
                    onBlur: setDescription
                  }, null, 8, ["content"]))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          (_ctx.booking.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    id: "issuedCheckBox",
                    class: "custom-control-input",
                    checked: props.booking.issued,
                    onChange: _cache[12] || (_cache[12] = ($event: any) => (toggleIssued()))
                  }, null, 40, _hoisted_28),
                  _hoisted_29
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            "data-dismiss": "modal",
            onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (hide()), ["prevent"]))
          }, " Cancel "),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            "data-dismiss": "modal",
            onClick: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (save()), ["prevent"])),
            disabled: isSaving.value || !savingAllowed.value
          }, " Save ", 8, _hoisted_30)
        ])
      ])
    ])
  ]))
}
}

})